import './Job.css';

interface Props {
  title: string;
}

export const Job = ({title}: Props) => {
  return <div className="job">
    {title}
  </div>
}